<script>
export default {
  created() {
  },
  props: {
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      codeDetail: {
          type: Object
      },
      selectOption: {
          type: Object
      },
      dialogOption: {
          type: Object
      }
  },
  data() {
      return {
          codeQuery: {
              id: '',
              title: '',
              bidTypeId: '',
            //   projectTypeId: ''
          },
          authQuery: {
              id: '',
              followStatus: ''
          }
      }
  },
  methods: {
      modelStatus(val) {
          this.dialogOption.show = val;
          this.initQuery();
      },
      initQuery() {
          switch(+this.dialogOption.type) {
              case 0:
                  this.$clearObject(this.codeQuery);
                  break;
              case 1:
                  this.$setObject(this.codeQuery,this.codeDetail);
                  break;
              case 2:
                  this.$setObject(this.authQuery,this.codeDetail);
                  break;
          }
      },
      async submit() {
        const {type} = this.dialogOption;
        const {code} = await this.codeEvent(type === 1 ? this.codeQuery : this.authQuery);
        if (Object.is(code, 200)) {
            this.searchEvent();
            this.$message.success(`${this.dialogOption.title}成功`);
        }
        this.dialogOption.show = false;
        this.$clearObject(this.codeQuery);
      }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
      codeDetail(val) {
          this.$setObject(this.codeQuery, val);
      }
  }
}
</script>
<template>
<div class="edit">
  <el-dialog
    :title="dialogOption.title"
    :width="dialogOption.width"
    :visible.sync="dialogOption.show"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="codeQuery" ref="information" v-if="dialogOption.type === 1">
      <el-form-item label="标题" label-width="80px">
          <el-input type="textarea" row="3" v-model="codeQuery.title"></el-input>
      </el-form-item>
      <el-form-item label="信息类型" label-width="80px">
          <el-select v-model="codeQuery.bidTypeId" class="common-width"
			   placeholder="信息类型"
			>
				<el-option
					v-for="item in selectOption.bidTypeId"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
      </el-form-item>
      <!-- <el-form-item label="项目类型" label-width="80px">
          <el-select v-model="codeQuery.projectTypeId" class="common-width"
			   placeholder="信息类型"
			>
				<el-option
					v-for="item in selectOption.projectTypeId"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
      </el-form-item>-->
    </el-form>
    <el-form :model="codeQuery" ref="information" v-if="dialogOption.type === 2">

      <el-form-item label="跟进状态" label-width="80px">
          <el-select v-model="authQuery.followStatus" class="common-width"
			   placeholder="跟进状态"
			>
				<el-option
					v-for="item in selectOption.followStatus"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="dialogOption.show = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submit" size="small">提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">


</style>
